import { render, staticRenderFns } from "./terminos_y_condiciones.vue?vue&type=template&id=99a22f84&scoped=true&"
import script from "./terminos_y_condiciones.vue?vue&type=script&lang=js&"
export * from "./terminos_y_condiciones.vue?vue&type=script&lang=js&"
import style0 from "./terminos_y_condiciones.vue?vue&type=style&index=0&id=99a22f84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a22f84",
  null
  
)

export default component.exports